import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchThemes = createAsyncThunk(
  "themes/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get("/themes", { params });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement thèmes");
    }
  }
);

export const createTheme = createAsyncThunk(
  "themes/create",
  async (themeData, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post("/themes", themeData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur création thème");
    }
  }
);

export const updateTheme = createAsyncThunk(
  "themes/update",
  async ({ id, themeData }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(`/themes/${id}`, themeData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur modification thème");
    }
  }
);

export const deleteTheme = createAsyncThunk(
  "themes/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/themes/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur suppression thème");
    }
  }
);

const themeSlice = createSlice({
  name: "themes",
  initialState: { list: [], loading: false, error: null, success: null, total: 0, page: 1, pages: 1 },
  reducers: {
    clearThemeMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchThemes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchThemes.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
        state.total = action.payload.total ?? state.list.length;
        state.page = action.payload.page ?? 1;
        state.pages = action.payload.pages ?? 1;
      })
      .addCase(fetchThemes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTheme.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
        state.success = "Thème créé avec succès.";
      })
      .addCase(createTheme.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateTheme.fulfilled, (state, action) => {
        const idx = state.list.findIndex((t) => t._id === action.payload._id);
        if (idx !== -1) state.list[idx] = action.payload;
        state.success = "Thème mis à jour avec succès.";
      })
      .addCase(updateTheme.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteTheme.fulfilled, (state, action) => {
        state.list = state.list.filter((t) => t._id !== action.payload);
        state.success = "Thème supprimé avec succès.";
      })
      .addCase(deleteTheme.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearThemeMessages } = themeSlice.actions;
export default themeSlice.reducer;

